import React, { useRef } from 'react'
import useOutsideClick from '../hooks/useClickOutside'
import Divider from './Divider'
import Button from 'antd/lib/button'

const styles = {
    mask: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1005,
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.45)',
        overflow: 'auto',
    },
    container: {
        maxWidth: '90%',
        padding: 4,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        zIndex: 1010,
        borderRadius: 10,
    },
    closeButton: {
        position: 'absolute',
        top: 15,
        right: 35,
        cursor: 'pointer',
        fontSize: 22,
        zIndex: 1,
    },
    header: {
        backgroundColor: '#fafafa',
        fontSize: 26,
        padding: '0.32em',
    },
    footer: {
        backgroundColor: '#fafafa',
        fontSize: 32,
        borderTop: '1px solid #d8d8d8',
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        width: '100%',
        display: 'flex',
        justifyContent: 'end',
        padding: '0.32em 1em 0.16em 1em'
    }
}

const Overlay = ({ children, visible, onClose, headerText, closebutton, footer, hideOk, onOK, okText }) => {
    const container = useRef()

    useOutsideClick(container, () => onClose())

    if (!visible) return null

    return (
        <div style={styles.mask}>
            <div style={styles.container} onClick={(event) => event.stopPropagation()}>
                <div style={styles.header}>
                    {headerText}
                    {closebutton && (
                        <div style={styles.closeButton}>
                            <span onClick={onClose}>X</span>
                        </div>
                    )}
                </div>
                <Divider />
                {children}
                {footer && (
                    <div style={styles.footer}>
                        <Button onClick={onClose} style={{marginRight: 20}}>Cancel</Button>
                        {!hideOk && <Button onClick={onOK} type='primary'>{okText ? okText : "Save"}</Button>}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Overlay
